import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {takeUntil} from "rxjs/operators";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReceivablesTransfer} from "../../../../shared/interface/receivables-transfer";
import {ReceivablesTransferService} from "../../../../shared/services/receivables-transfer.service";
import {
  ConfirmDialogWithReasonComponent
} from "../../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {RECEIVABLES_IMPORT_ROW_STATUS} from "../../../../shared/services/dict.service";

@Component({
  selector: 'app-transfer-details',
  templateUrl: './transfer-details.component.html',
  styleUrls: ['./transfer-details.component.scss']
})
export class TransferDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  receivablesTransferId: string;
  receivablesTransferObject?: ReceivablesTransfer;
  receivablesTransfer: ReplaySubject<ReceivablesTransfer> = new ReplaySubject<ReceivablesTransfer>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  constructor( private route: ActivatedRoute,
               private receivablesTransferService: ReceivablesTransferService,
               private snack: MatSnackBar,
               private dialog: MatDialog,
               private auth: AuthService,
  )
  {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.receivablesTransferId = params.id;
        this.loadTransfer();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadTransfer(): void {
    this.receivablesTransferService.get(this.receivablesTransferId).subscribe((receivablesTransfer: ReceivablesTransfer) => {
      this.receivablesTransfer.next(receivablesTransfer);
      this.receivablesTransferObject = receivablesTransfer;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
